import { 
  Star as RatingIcon,
  RadioButtonChecked as MultipleChoiceIcon,
  CheckBox as MultipleSelectIcon,
  ToggleOn as BooleanIcon,
  MicNone as MicIcon,
  PlayCircle as VideoIcon,
  DragIndicator as DragIcon,
  Help as HelpIcon,
  PictureAsPdf as PictureAsPdfIcon,
  Flip as FlipIcon,
  Description as DescriptionIcon,
  TextFields as TextFieldsIcon,
} from 'lib/icons';
import { QuestionType } from '../types';

export const getQuestionTypeIcon = (type: QuestionType) => {
  switch (type) {
    case 'rating':
      return <RatingIcon fontSize="small" />;
    case 'multiple_choice':
      return <MultipleChoiceIcon fontSize="small" />;
    case 'audio':
      return <MicIcon fontSize="small" />;
    case 'text_or_audio':
      return <MicIcon fontSize="small" />;
    case 'boolean':
      return <BooleanIcon fontSize="small" />;
    case 'multiple_select':
      return <MultipleSelectIcon fontSize="small" />;
    case 'multiple_reveal':
      return <FlipIcon fontSize="small" />;
    case 'accordion':
      return <DescriptionIcon fontSize="small" />;
    case 'additional_resources':
      return <DescriptionIcon fontSize="small" />;
    case 'description':
      return <DescriptionIcon fontSize="small" />;
    case 'custom_screen':
      return <DescriptionIcon fontSize="small" />;
    case 'drag_and_drop_ranking':
      return <DragIcon fontSize="small" />;
    case 'drag_and_drop':
      return <DragIcon fontSize="small" />;
    case 'video_player':
      return <VideoIcon fontSize="small" />;
    case 'pdf':
      return <PictureAsPdfIcon fontSize="small" />;
    case 'text_list':
      return <TextFieldsIcon fontSize="small" />;
    case 'ai_summary':
      return <DescriptionIcon fontSize="small" />;
    default:
      return <HelpIcon fontSize="small" />;
  }
};

export const getQuestionTypeDisplay = (type: QuestionType): string => {
  switch (type) {
    case 'rating':
      return 'Rating';
    case 'multiple_choice':
      return 'Multiple Choice';
    case 'audio':
      return 'Audio Response';
    case 'text_or_audio':
      return 'Text or Audio Response';
    case 'description':
      return 'Description';
    case 'boolean':
      return 'Yes/No';
    case 'multiple_select':
      return 'Multiple Select';
    case 'multiple_reveal':
      return 'Multiple Reveal';
    case 'accordion':
      return 'Accordion';
    case 'additional_resources':
      return 'Additional Resources';
    case 'drag_and_drop':
      return 'Drag and Drop';
    case 'drag_and_drop_ranking':
      return 'Drag and Drop Ranking';
    case 'video_player':
      return 'Video Player';
    case 'pdf':
      return 'PDF';
    case 'text_list':
      return 'Text List';
    case 'custom_screen':
      return 'Custom Screen';
    case 'ai_summary':
      return 'AI Summary';
    default:
      return 'Unknown';
  }
};
export const LEGACY_QUESTION_TYPE_ALIASES: Record<string, QuestionType> = {
  styled_boolean: 'boolean',
  true_false: 'boolean',
  free_response: 'text_or_audio',
  text_or_audio_response: 'text_or_audio',
  text_audio: 'text_or_audio',
  audio_response: 'text_or_audio',
  text: 'description',
  subtitle_here: 'description',
  callback: 'callback_summary',
  radar: 'radar_chart',
  drag_and_drop_horizontal: 'horizontal_drag_drop',
  ranking_drag_drop: 'drag_and_drop_ranking',
  'drag and drop ranking': 'drag_and_drop_ranking',
  accordian: 'accordion',
  'additional resources': 'additional_resources',
  additionalresources: 'additional_resources',
  list: 'text_list',
  'text list': 'text_list',
  'custom-screen': 'custom_screen',
};

export const normalizeQuestionType = (rawType: string | null | undefined): string => {
  const value = (rawType ?? '').toLowerCase();
  return LEGACY_QUESTION_TYPE_ALIASES[value] ?? value;
};
